module.exports = __webpack_public_path__ + "static/media/yandex-device-smarphone.3f53bf60.png";